export default __webpack_public_path__ + "09fe0cd.png";